export default __webpack_public_path__ + "static/media/fx2.4e7a4662.png";